import ShCard from '@/components/Helpers/ShCard';

export default {
  name: 'LayoutForSingleConfigurationRow',

  components: {
    ShCard,
  },

  props: {
    title: {
      type: String,
      default: 'Confguration Title',
    },
    type: {
      type: String,
      default: null,
    },
    marginBottom: {
      type: String,
      default: '0px',
    },
    position: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
  },
};
